import lozad from 'lozad';
import mixitup from 'mixitup';

export default {
  init() {
    // JavaScript to be fired on all pages
    const observer = lozad();
    observer.observe();

    (function($) {
      // Mobile Nav
      $('#nav-primary-toggle').click(function() {
        $('.nav-primary').toggleClass('open');
        $('.nav-backdrop').toggleClass('show');
      });

      $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><i class="fa fa-chevron-down fa-xs"></i></div>');

      var timing = 200;

      $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function() {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideToggle(timing);
        }
      });

      $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function() {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideToggle(timing);
        }
      });

      // Desktop nav
      $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function() {
        if( $(window).innerWidth() > 991 ) {
          var target = $(this).find('> ul.sub-menu');
          var width = $(target).outerWidth();

          var right_of_screen = $(window).innerWidth();
          var right_of_parent = $(this).offset().left + $(this).outerWidth();
          var right_of_element = right_of_parent + width;

          if (right_of_screen > right_of_element){
            $(target).css('transform', 'translateX(100%)');
            $(target).css('right', '0');
          } else {
            $(target).css('transform', 'translateX(-100%)');
            $(target).css('left', '0');
          }
        }
      });

      // Slick
      $('.slick-banner').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        pauseOnHover: false,
      });

      $('.banner-products').slick({
        dots: false,
        arrows: true,
        // fade: true,
        fade: false,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        mobileFirst: true,
        responsive: [ 
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
     
      $('.related-products').slick({
        dots: false,
        arrows: true,
        // fade: true,
        fade: false,
        cssEase: 'ease-in-out',
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        // mobileFirst: true,
        responsive: [ 
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 567,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      }); 

      $('.slick-accreditations').slick({
        dots: false,
        arrows: false,
        // prevArrow: $('.section_page-accreditations .slick-arrow-left'), nextArrow: $('.section_page-accreditations .slick-arrow-right'),
        cssEase: 'ease-in-out',
        slidesToShow: 5, 
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 667,
            settings: {
              fade: true,
              slidesToShow: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              fade: false,
              slidesToShow: 3,
              arrows: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              fade: false,
              slidesToShow: 4,
              arrows: false,
            },
          },
          {
            breakpoint: 1440,
            settings: {
              fade: false,
              slidesToShow: 5,
              arrows: false,
            },
          },
        ],
      })

      $('.slider-arrows .slider-prev').click(function() {
        $(this).parent().next().slick('slickPrev');
      });
      $('.slider-arrows .slick-next').click(function() {
        $(this).parent().next().slick('slickNext');
      });

      $('.slick-p').click(function() {
        $(this).parent().prev().slick('slickPrev');
      });
      $('.slick-n').click(function() {
        $(this).parent().prev().slick('slickNext');
      });

      $('.slick-testimonials').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.section_page-testimonials .slick-left').click(function(){
        $('.slick-testimonials').slick('slickPrev');
      })
    
      $('.section_page-testimonials .slick-right').click(function(){
        $('.slick-testimonials').slick('slickNext');
      })

      // Smooth scrolls behaviour
      $(document).ready(function(){
        // Add smooth scrolling to all links
        $('a').on('click', function(event) {
      
          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== '') {
            // Prevent default anchor click behavior
            event.preventDefault();
      
            // Store hash
            var hash = this.hash;
      
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
              scrollTop: $(hash).offset().top,
            }, 1200, function(){
      
              // Add hash (#) to URL when done scrolling (default click behavior)
              window.location.hash = hash;
            });
          } // End if
        });
      });

      
      // FAQ & Product info Control 
      $('.faq-wrapper .heading').each(function (i, el) {
        $(el).on('click', function () {
          console.log(el);
          $(el).parent().toggleClass('collapsed');
        })
      })
      
      // Videos Page MIXITUP
      if(document.querySelector('.videos-mixitup') !== null) {
        mixitup('.videos-mixitup');
      }      

      // DOWNLOADS PAGE MIXITUP
      if(document.querySelector('.downloads-mixitup') !== null) {
        mixitup('.downloads-mixitup');
      }

      // GALLERY PAGE MIXITUP

      var containerEl = document.querySelector('#mixitup-container');
      if(containerEl !== null) {
        var mixer = mixitup(containerEl, {
          selectors: {
            target: '.item',
            control: '[data-mixitup-control]',
          }, 
          callbacks: {
            onMixClick: function() {
              // document.getElementById('report').innerHTML = 'Product Selected: ' + this.innerText ;
            },
            onMixEnd: function(state) {
              $('.mix').removeClass('fb-gallery');
              $('.mix').removeClass('mix-selected');
              $('.mix').removeClass('pull-element');
              var i = 0;
              state.show.forEach( function( element ) {
                var test = (i + 2) % 3 === 0;
                if(test) {
                  $(element).addClass('pull-element');
                }
                
                $(element).addClass('fb-gallery');
                $(element).addClass('mix-selected');
                i++;
              })
              // document.getElementById('report').innerHTML = 'Product Selected: ' + this.innerText ;
            },
          },
        });
      }

      $('.filters-row button.reveal-filters').on('click', function() {
        $('.filters-row dd').toggle();
      });

      if(mixer) {
        console.log('mixing...');
      }

      $('#mixitup-container').fancybox({
        selector: '.fb-gallery>a',
        loop: true,
      });

      $('.section_page-inspiration-gallery').fancybox({
        selector: '.fb-gallery>a',
        loop: true,
      });

      //START Sticky CTA 
      $('.sticky-cta-hide').on('click', function() {
        $('.sticky-nav').toggleClass('minimised');
      });
      $(window).scroll(function() {
        if ($(document).scrollTop() > 400) {
          $('.sticky-nav').removeClass('hidden');
          $('.sticky-nav').addClass('fixed');
        }
        else {
          $('.sticky-nav').addClass('hidden');
          $('.sticky-nav').removeClass('fixed');
        }
      });
      //END Sticky CTA

      $('.inspiration-nav>.nav-item').on('click', function() {
        var $this = $(this);
        console.log($this.text());

        var tab = $this.text();

        switch(tab) {
          case 'Gallery':
            $('.section_page-inspiration-gallery .brochure').hide();
            $('.section_page-inspiration-gallery .video').hide();
            $('.section_page-inspiration-gallery img').show();
            break;
          case 'Brochures':
            $('.section_page-inspiration-gallery .brochure').show();
            $('.section_page-inspiration-gallery .video').hide();
            $('.section_page-inspiration-gallery img').hide();
            break;
          case 'Videos':
            $('.section_page-inspiration-gallery .brochure').hide();
            $('.section_page-inspiration-gallery .video').show();
            $('.section_page-inspiration-gallery img').hide();
            break;
        }

        $('.inspiration-nav>.nav-item').removeClass('selected');
        $this.addClass('selected');
      });

      // Cookie Policy
      $.fn.CookieNotice = function() {
        if (!localStorage.getItem('cookie-notice-dismissed')) {
          var notice = this;
          setTimeout(function() {
            notice.addClass('active');
          }, 1000);
        }
        this.addClass('cookie-notice');
        return this
      }
      $(document).on('click', '.cookie-notice-dismiss', function() {
        localStorage.setItem('cookie-notice-dismissed', true);
        $(this).parents('.cookie-notice').removeClass('active');
      })
      $('#cookie-notice').CookieNotice();

      // Share Button
      $('.page-share').click(function() {
        if( navigator.share ) {
          navigator.share({
            title: 'Share This Page',
            url: 'https://google.com',
          }).then(() => {
            console.log('Thanks for sharing!');
          })
          .catch(err => {
            console.log('Couldnt share because of', err.message);
          });
        } else {
          $('#panel-share').toggleClass('active');
          console.log('navigator.share not supported!')
        }
      });

      $('.panel-share-close').click(function() {
        $('#panel-share').removeClass('active');
      });
    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js